<template>
    <div class="ui-process">
        <div v-for="(step, index) in filteredSteps"
             :key="index"
             class="ui-process__item"
             :class="{'_collapsed': !expanded, '_first': index === 0}"
             @click="!expanded ? expanded = !expanded : null"
        >
            <div class="ui-process__marker" :class="{'_hide': !expanded}">
                <div class="ui-process__marker-icon-wrapper"
                     :class="{'_current': isCurrent(index), '_done': isDone(index)}"
                >
                    <icon :name="isDone(index) ? 'check-thin' : step.icon"
                          :color="isDone(index) || isCurrent(index) ? '#fff' : '#9C9BA9'"
                          :width="isDone(index) || isLast(index) ? '10px' : '16px'"
                          :height="isDone(index) || isLast(index) ? '10px' : '16px'"
                    />
                </div>
                <div class="ui-process__marker-line" v-if="!isLast(index)">
                    <div class="ui-process__marker-line-inner" :class="{'_highlight': isDone(index)}"/>
                </div>
            </div>

            <div class="ui-process__content" :class="{'_current': isCurrent(index)}">
                <ui-label
                    :title="step.title"
                    :theme="isDone(index) ? 'positive' : (isCurrent(index) ? 'secondary' : 'fade')"
                    is-uppercase
                />
                <div class="description" v-if="expanded && step.description">
                    <div v-if="step.description" v-html="step.description" />
                    <div v-if="step.instructionUrl">
                        <a v-bind:href="step.instructionUrl" target="_blank">Инструкция</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="ui-process__toggle" @click="expanded = !expanded">
            <div class="ui-process__toggle-title">
                {{ expanded ? 'Скрыть' : 'Узнать подробнее' }}
            </div>
            <div class="ui-process__toggle-icon" :class="{'_expanded': expanded}">
                <icon name="triangle" width="16" height="16" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ui-process',
    props: {
        /**
         * @type {Array<{
         *   title: string,
         *   icon: string,
         *   description?: string,
         *   isCurrent: boolean,
         *   instructionUrl?: string
         * }>}
         */
        steps: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            expanded: true,
        };
    },
    computed: {
        filteredSteps() {
            if (this.expanded) return this.steps;
            return this.steps.filter(step => step.isCurrent);
        },
        currentStepIndex() {
            return this.filteredSteps.findIndex(step => step.isCurrent);
        },
        currentStep() {
            return this.steps[this.currentStepIndex];
        },
    },
    methods: {
        isComponent(desc) {
            return typeof desc === 'object' || typeof desc === 'function';
        },
        isDone(index) {
            return index < this.currentStepIndex;
        },
        isCurrent(index) {
            return index === this.currentStepIndex;
        },
        isLast(index) {
            return index === this.filteredSteps.length - 1;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.ui-process {
    position: relative;

    &__item {
        display: flex;
        gap: 16px;

        @media @media-sm-down {
            gap: 12px;

            &._first {
                padding-right: 18px;
            }
        }

        &._collapsed {
            cursor: pointer;
        }
    }

    &__marker {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 54px;

        @media @media-sm-down {
            width: 48px;
        }

        &._hide {
            opacity: 0;
        }

        &-icon-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            background-color: @color-gray-light;
            border-radius: 6px;

            &._current {
                background-color: @color-primary;
            }

            &._done {
                background-color: @color-positive;
            }
        }
        &-line {
            display: flex;
            justify-content: center;
            flex: 1;
            width: 100%;
            height: 100%;
            padding: 4px 0;

            &-inner {
                height: 100%;
                width: 0;
                border-right: 2px dashed @color-gray-light;

                &._highlight {
                    border-right: 2px dashed @color-positive;
                }
            }
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding-bottom: 16px;

        .typography-body();

        color: @color-gray-main;

        &._current {
            color: @color-gray-darker;
        }
    }

    &__toggle {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        gap: 8px;
        align-items: center;
        cursor: pointer;

        &-title {
            .typography-body();

            text-decoration: underline;
        }

        @media @media-xs-down {
            &-title {
                display: none;
            }
        }

        &-icon {
            transform: rotate(-180deg);
            transition: transform @duration-fast ease-in-out;

            &._expanded {
                transform: rotate(0deg);
            }
        }
    }
}
</style>
